import { Navigate } from "react-router-dom";

// Keep saved links and older back destinations working; the picker now lives in the Mirror menu.
export default function Modules() {
  return <Navigate to="/mirror?menu=modules" replace />;
}
